import vue from 'vue';

const bus = new vue();

export default bus;